<template>
<transition name="intro">
    <div v-if="showIntroTutorial" class="intro-tutorial is-overlay">
        <h5 class="guide-header subtitle is-5 has-text-centered">
            Quick Guide
        </h5>
        <div class="guide-body content">
            <ul>
                <li>
                    <p>
                        You need to click this button to grant permission.
                        If you don't, users won't be able to submit suggestions.
                    </p>
                    <template v-if="oauthState !== $const.OAUTH_SUCCESS">
                        <p>You can grant permission now or later.</p>
                        <div><OAuthButton :oauthState.sync="oauthState"/></div>
                    </template>
                    <p v-else>Thanks!</p>
                </li>
                <li>
                    You can directly reply to suggestions and
                    mark them as completed.
                </li>
                <li>
                    Visit the
                    <a :href="configPageUrl" target="_blank">configuration page</a>.
                    You can customize a lot
                    of stuff, it's awesome. Also I worked really hard on it.
                </li>
            </ul>
        </div>
        <div class="guide-footer">
            <button @click="closeTutorial" class="button is-success is-fullwidth">
                Okay!
            </button>
        </div>
    </div>
</transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import OAuthButton from '@/components/OAuthButton'
import * as M from '@/store/mutations'

export default {
    name: 'IntroTutorial',
    data: () => ({
        oauthState: null,
    }),
    computed: {
        ...mapState(['showIntroTutorial']),
        ...mapGetters(['configPageUrl']),
    },
    methods: {
        closeTutorial () {
            this.$store.commit(M.TOGGLE_BROADCASTER_INTRO_TUTORIAL, { show: false })
            this.$store.dispatch('updateNotificationReadDate')
        }
    },
    components: {
        OAuthButton
    }
}
</script>

<style lang="scss" scoped>
.intro-tutorial {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    z-index: 10;
    background: var(--bg-color);
    .guide-header {
        padding-top: 1rem;
        margin-bottom: 0;
    }
    .guide-body {
        padding: 0 1rem;
        margin: 0;
    }
    .guide-footer {
        position: sticky;
        bottom: 0;
        padding: 1rem;
        background: var(--bg-color);
    }
}

.content {
    font-size: 0.9rem;
    li {
        margin-bottom: 1rem;
    }
}

.intro-enter-active {
    transition: 0.35s;
}

.intro-enter {
    opacity: 0;
}

.intro-leave-active {
    transition: 0.6s cubic-bezier(0.25, 1, 0.5, 1);
}

.intro-leave-to {
    transform: translateY(100%);
}

</style>
